<script setup>
import { WButton } from '@alice-health/wonderland-vue'
import { computed } from 'vue'

import { HTableScroll } from '@/components/shared/atoms'
import { useDateFormatter } from '@/libs/date'
import { useStore } from '@/wrappers/store'

import { CChannelSla } from '..'

const { formatDate, timeDifference } = useDateFormatter()
const { mapState } = useStore()
const { administrativeDashboard } = mapState('permissions')

defineProps({
  channels: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['sendChannel'])

const thead = [
  {
    title: 'SLA'
  },
  {
    title: 'Criação'
  },
  {
    title: 'Duração'
  },
  {
    title: 'Canal'
  }
]

const sendSelectedChannel = channel => {
  emit('sendChannel', channel)
}
const hasPermissionToViewChannels = computed(
  () => administrativeDashboard.value.viewChannel
)

const filteredHeaders = computed(() => {
  return hasPermissionToViewChannels.value
    ? thead
    : thead.filter(header => header.title !== 'Canal')
})
</script>

<template>
  <HTableScroll
    :headers="filteredHeaders"
    :rows="channels"
    class="channels__table"
  >
    <template #row="{ row }">
      <td>
        <CChannelSla :channel="row" style="padding-left: 15px" />
      </td>
      <td>
        {{ formatDate(row.createdAt) }}
      </td>
      <td style="padding-left: 12px">
        {{ timeDifference(row.createdAt) }}
      </td>
      <td v-if="hasPermissionToViewChannels" class="icons">
        <WButton
          variant="tertiary"
          icon-button
          icon="icChat"
          @click="sendSelectedChannel(row)"
        />
        <WButton
          v-if="row.administrativeDetails?.channelMonitored"
          variant="tertiary"
          icon-button
          icon="icChatRead"
        />
      </td>
    </template>
  </HTableScroll>
</template>

<style lang="scss" scoped>
.channels__table {
  max-height: 80%;
}
.icons {
  display: flex;
  flex-direction: row;
  padding-left: 5px;
}
</style>
